import { setSyncClientInfo } from '@nimbalyst/collab-bundle/docs-ui';
import packageInfo from '../../package.json';

/** Configure the bundle-wide sync identity before any web socket is created. */
export function initializeWebSyncClientInfo(): void {
  setSyncClientInfo({
    platform: 'web',
    version: packageInfo.version,
  });
}
